<template>
  <div>
    <el-container v-if="isPc" class="page-component__scroll">
      <el-header>
        <div class="header_menu">
          <router-link :to="{ path: '/' }">
            <!-- <p :style="'background-image:url('+$imgUrl + $store.state.logo+')'"></p> -->
            <img :src="$imgUrl + $store.state.logo" />
            <!-- <img src="https://qinius.ts960.com/1634732723972.jpg" /> -->
            <span>深圳台商協會</span>
          </router-link>
          <el-menu
            class="el-menu-demo"
            mode="horizontal"
            text-color="#222222"
            active-text-color="#20317F"
            unique-opened
            router
            :default-active="activePath"
            @select="handleSelect"
          >
            <el-menu-item
              v-for="(item, index) in menuRes"
              :key="index"
              :index="index + ''"
              :route="`${item.path}`"
              :disabled="index == 1"
            >
              <a v-if="index == 1" :href="item.path" target="_blank">{{
                item.name
              }}</a>
              <span v-else>{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
          <div class="header_btns">
            <!-- <i class="el-icon-bell"></i> -->
            <!-- <i class="el-icon-search"></i> -->
            <el-tag @click="fnChangeLang">{{ lang }}</el-tag>
            <i class="el-icon-bell" @click="fnToMyMessage"
              ><b v-if="msgNum > 0">{{ msgNum > 10 ? "" : msgNum }}</b>
            </i>
            <router-link :to="{ path: '/search' }"
              ><i class="el-icon-search"></i
            ></router-link>
            <i class="el-icon-star-off" @click="fnToMyCollection"></i>
            <!-- <i class="el-icon-star-off"></i> -->
            <el-button
              v-if="!validToken"
              type="primary"
              @click="dialogVisible = true"
              >登录</el-button
            >
            <div v-else class="avatar">
              <router-link :to="{ path: '/person_center' }">
                <el-avatar
                  icon="el-icon-user-solid"
                  v-if="!userInfo.member_photo"
                ></el-avatar>
                <el-avatar
                  :src="$imgUrl + userInfo.member_photo"
                  v-else
                ></el-avatar>
              </router-link>
            </div>
          </div>
        </div>
      </el-header>
      <router-view></router-view>
      <el-dialog
        :visible.sync="dialogVisible"
        width="600px"
        center
        :show-close="false"
      >
        <div class="login_container">
          <div class="login_box">
            <div class="avatar_box">
              <h3>深圳台協</h3>
              <i class="el-icon-close" @click="dialogVisible = false"></i>
              <!-- <img :src="$imgUrl+$store.state.logo" alt="" /> -->
            </div>
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              class="tabs_menu"
            >
              <el-tab-pane label="手機號註冊" name="first" v-if="!isForget">
                <el-form
                  ref="registerFormRef1"
                  :model="registerForm"
                  :rules="rules"
                  label-width="0"
                  class="login_form"
                >
                  <el-form-item prop="userPhone">
                    <el-input
                      v-model="registerForm.userPhone"
                      prefix-icon="el-icon-mobile-phone"
                      placeholder="請輸入您的手機號"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="verifyCode" class="code_input">
                    <el-input
                      v-model="registerForm.verifyCode"
                      prefix-icon="el-icon-key"
                      placeholder="請輸入動態密碼"
                    ></el-input>

                    <div
                      class="code_btn"
                      v-show="show"
                      @click="fnGetVerificationCode(1)"
                    >
                      獲取驗證碼
                    </div>
                    <span v-show="!show" class="count"
                      >{{ count }}s後重新獲取</span
                    >
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      v-model="registerForm.password"
                      type="password"
                      prefix-icon="el-icon-lock"
                      placeholder="密碼以字母開頭，長度6~18，只包含字母、數字和下劃線"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="agreement" class="tips">
                    <el-checkbox
                      v-model="registerForm.agreement"
                      label="勾選代表您同意"
                      name="type"
                    ></el-checkbox>
                    <a
                      href="https://api2.ts960.com/sztx/sztx-user.html"
                      target="_blank"
                      >《深圳台協網站用戶協議》</a
                    >
                  </el-form-item>
                  <el-form-item class="btn">
                    <el-button @click="register">註冊</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="手機號登錄" name="second" v-if="!isForget">
                <el-form
                  ref="registerFormRef3"
                  :model="registerForm"
                  :rules="rules"
                  label-width="0"
                  class="login_form"
                >
                  <el-form-item prop="userPhoneLogin">
                    <el-input
                      v-model="registerForm.userPhoneLogin"
                      prefix-icon="el-icon-mobile-phone"
                      placeholder="请請輸入您的手機號"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password" v-if="!useCode">
                    <el-input
                      v-model="registerForm.password"
                      type="password"
                      prefix-icon="el-icon-lock"
                      placeholder="請輸入您的密碼"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="verifyCode" class="code_input" v-else>
                    <el-input
                      v-model="registerForm.verifyCode"
                      prefix-icon="el-icon-key"
                      placeholder="請輸入動態密碼"
                    ></el-input>
                    <div
                      class="code_btn"
                      v-show="show"
                      @click="fnGetVerificationCode(3)"
                    >
                      獲取驗證碼
                    </div>
                    <span v-show="!show" class="count"
                      >{{ count }}s後重新獲取</span
                    >
                  </el-form-item>
                  <div class="remmber_btn">
                    <div>
                      <span @click="useCode = true" v-if="!useCode"
                        >短信驗證碼登錄</span
                      >
                      <span @click="useCode = false" v-else>帳號密碼登錄</span>
                    </div>
                    <div>
                      <span @click="fnChangeIsForget">忘記密碼？</span
                      ><span @click="activeName = 'first'">免費註冊</span>
                    </div>
                  </div>
                  <el-form-item class="btn">
                    <el-button @click="fnToLogin">登錄</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="忘記密碼" name="first" v-if="isForget">
                <el-form
                  ref="registerFormRef2"
                  :model="registerForm"
                  :rules="rules"
                  label-width="0"
                  class="login_form"
                >
                  <el-form-item prop="userPhoneLogin">
                    <el-input
                      v-model="registerForm.userPhoneLogin"
                      prefix-icon="el-icon-mobile-phone"
                      placeholder="请請輸入您的手機號"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="verifyCode" class="code_input">
                    <el-input
                      v-model="registerForm.verifyCode"
                      prefix-icon="el-icon-key"
                      placeholder="請輸入動態密碼"
                    ></el-input>
                    <div
                      class="code_btn"
                      v-show="show"
                      @click="fnGetVerificationCode(2)"
                    >
                      获取验证码
                    </div>
                    <span v-show="!show" class="count"
                      >{{ count }}s后重新获取</span
                    >
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      v-model="registerForm.password"
                      type="password"
                      prefix-icon="el-icon-lock"
                      placeholder="請重設密碼"
                    ></el-input>
                  </el-form-item>
                  <div class="remmber_btn">
                    <div>
                      <span @click="fnChangeCodeLogin">短信驗證碼登錄 </span>
                      <span @click="fnchangePasswordLogin"> 帳號密碼登錄</span>
                    </div>
                    <div><span @click="fnChangeRegister">免費註冊</span></div>
                  </div>
                  <el-form-item class="btn">
                    <el-button @click="fnModifyPassword">修改密碼</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="isHasAssociation"
        title="升級會員"
        width="450px"
        center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="tips_pop"
      >
        <i class="el-icon-close" @click="isHasAssociation = false"></i>
        <p>您目前是普通會員，升級協會會員享受更多權益</p>
        <div class="pop-con">
          <button class="little_hand" @click="fnToMyRights">立即升級</button>
          <button class="little_hand" @click="isHasAssociation = false">
            以後再說
          </button>
        </div>
      </el-dialog>
    </el-container>
    <div v-else class="m-header">
      <div class="nav">
        <router-link :to="{ name: '/' }"><span>首頁</span></router-link>
        <i class="el-icon-s-operation" @click="drawer = true"></i>
      </div>
      <div style="width: 100%; height: 45px;background: #20317F;"></div>
      <el-drawer
        title="欄目"
        :visible.sync="drawer"
        direction="ltr"
        size="70%"
        :with-header="false"
      >
        <el-menu
          class="el-menu-demo"
          mode="vertical"
          text-color="#414141"
          active-text-color="#3135CB"
          unique-opened
          router
          :default-active="activePath"
        >
          <!-- <el-menu-item
            v-for="(item, index) in menuRes"
            :key="index"
            :index="index + ''"
            :route="`${item.path}`"
            @click="drawer = false"
          >
            {{ item.name }}
          </el-menu-item> -->

          <el-menu-item
              v-for="(item, index) in menuRes"
              :key="index"
              :index="index + ''"
              :route="`${item.path}`"
              :disabled="index == 1"
              @click="drawer = false"
            >
              
              <a  v-if="index==1" :href="item.path" target="_blank">{{ item.name }}</a>
              <span v-else>{{ item.name }}</span>
            </el-menu-item>
          <!-- <el-menu-item disabled :index="menuRes.length + ''"
            ><a href="https://getintern.thinkpassion.cn/" target="_blank"
              >實習報名</a
            >
          </el-menu-item> -->
        </el-menu>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    const validatePhone = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手機號不能為空"));
      } else {
        const reg =
          /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
        // console.log('sasaj======',reg.test(value));
        if (reg.test(value)) {
          // this.checkPhone()
          const { data: res } = await this.$http.post(
            `/api/v2/account/initVariable/${this.registerForm.userPhone}`
          );
          if (!res.sucess) return this.$message.error("獲取失敗");
          if (res.code === "403")
            return callback(
              new Error("該手機號已經註冊過，請更換手機號或直擊登錄")
            );
          // console.log('sdhjdhsjd=====',res)
          callback();
        } else {
          return callback(new Error("請輸入正確的手機號"));
        }
      }
    };
    // 设置密码的验证规则
    const checkPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {
        const reg = /^[a-zA-Z]\w{5,17}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(
            new Error("密碼以字母開頭，長度6~18，只包含字母、數字和下劃線")
          );
        }
      }
    };
    // 设置协议规则
    const checkAgreement = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        callback(new Error("請先閱讀協議並勾選"));
      } else {
        callback();
      }
    };
    const validatePhoneLogin = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手機號不能為空"));
      } else {
        const reg =
          /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
        // console.log('fggfgssaj======',reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("請輸入正確的手機號"));
        }
      }
    };
    return {
      menuRes: [
        {
          name: "首頁",
          path: "/",
          type: "/",
        },
        {
          name: "實習報名",
          path: "https://intern.upapi.cn/portal/#/",
          type: "https://intern.upapi.cn/portal/#/",
        },
        {
          name: "資訊",
          path: "/information/0",
          type: "/information",
        },
        // {
        //   name: "抗疫助企",
        //   path: "/information/2",
        //   type: "/information/2",
        // },
        {
          name: "電子雜誌",
          path: "/magazine",
          type: "/magazine",
        },
        {
          name: "企業會員",
          path: "/company_member_list/1",
          type: "/company_member_list",
        },
        {
          name: "協會公告",
          path: "/policy/0",
          type: "/policy",
        },
        {
          name: "匯課堂",
          path: "/policy/1",
          type: "/policy",
        },
        {
          name: "專項服務",
          path: "/policy/2",
          type: "/policy",
        },
        {
          name: "采購需求",
          path: "/Invest",
          type: "/Invest",
        },
        {
          name: "政策文件",
          path: "/policy/3",
          type: "/policy",
        },
        {
          name: "關於協會",
          path: "/introduce",
          type: "/introduce",
        },
        {
          name: "指南",
          path: "/guide",
          type: "/guide",
        },
        {
          name: "繳費",
          path: "/fee",
          type: "/fee",
        },
      ],
      lang: "",
      activeName: "second",
      useCode: true, //登录验证码登录显示
      isForget: false, //是否忘记密码
      show: true,
      count: "",
      timer: null,
      registerForm: {
        userPhone: "",
        verifyCode: "",
        password: "",
        agreement: false,
        userPhoneLogin: "",
      },
      rules: {
        userPhone: [
          { required: true, message: "請輸入手機號", trigger: "blur" },
          { validator: validatePhone, trigger: ["blur", "change"] },
        ],
        verifyCode: [
          { required: true, message: "請輸入驗證碼", trigger: "blur" },
          { min: 6, max: 6, message: "驗證碼錯誤", trigger: "blur" },
        ],
        // 密码
        password: [
          { required: true, message: "請輸入密碼", trigger: "blur" },
          { min: 6, max: 18, message: "長度在 6 到 18 位", trigger: "change" },
          { validator: checkPass, trigger: "change" },
        ],
        agreement: [
          {
            required: true,
            validator: checkAgreement,
            message: "請先閱讀協議並勾選",
            trigger: "change",
          },
        ],
        userPhoneLogin: [
          { required: true, message: "請輸入手機號", trigger: "blur" },
          { validator: validatePhoneLogin, trigger: ["blur", "change"] },
        ],
      },
      activePath: "0",
      dialogVisible: false,
      isHasAssociation: false,
      isLogined: false, //判斷是否案登錄按鈕
      // 移动端
      drawer: false,
    };
  },
  computed: {
    ...mapState([
      "isPc",
      "headerMenuList",
      "mobileMenu",
      "infoRes",
      "validToken",
      "userInfo",
      "user_id",
      "msgNum",
      "isDialogVisible",
    ]),
  },
  methods: {
    fnChangeLang() {
      let locale = sessionStorage.getItem("language") || "";
      let temp = locale === "s" ? "t" : "s";
      sessionStorage.setItem("language", temp);
      this.$zhTran();
      this.lang =
        sessionStorage.getItem("language") &&
        sessionStorage.getItem("language") == "s"
          ? "繁体"
          : "簡體";
    },
    saveNavState(activePath) {
      window.sessionStorage.setItem("activePath", activePath);
      this.activePath = activePath;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    // 消息
    fnToMyMessage() {
      if (!this.validToken) {
        this.dialogVisible = true;
      } else {
        this.$router.push({
          path: `/my_message`,
        });
      }
    },
    // 收藏
    fnToMyCollection() {
      if (!this.validToken) {
        this.dialogVisible = true;
      } else {
        this.$router.push({
          path: `/my_collection`,
        });
      }
    },
    //短信验证码登录
    fnChangeCodeLogin() {
      this.isForget = false;
      this.activeName = "second";
      this.useCode = true;
    },
    //账号密码登录
    fnchangePasswordLogin() {
      this.isForget = false;
      this.activeName = "second";
      this.useCode = false;
    },
    //免费注册
    fnChangeRegister() {
      this.isForget = false;
      this.activeName = "first";
    },
    //忘记密码
    fnChangeIsForget() {
      this.isForget = true;
      this.activeName = "first";
    },
    //获取验证码
    fnGetVerificationCode(th) {
      let paramsName = th == 1 ? "userPhone" : "userPhoneLogin";
      // console.log(this.$refs)
      this.$refs["registerFormRef" + th].validateField(
        paramsName,
        async (valid) => {
          if (valid) return;
          // console.log(valid)
          const { data: res } = await this.$http.get(
            `api/v2/account/${this.registerForm[paramsName]}`
          );
          if (!res.sucess) return this.$message.error("獲取失敗");
          this.$message.success("獲取成功");
          // console.log(res)
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          // window.sessionStorage.setItem('token',333)
          // this.$router.push('/home')
        }
      );
      //window.sessionStorage.clear  ====清空token
    },
    //注册
    register() {
      this.$refs.registerFormRef1.validate(async (valid) => {
        if (!valid) return;
        // console.log(valid)
        const { data: res } = await this.$http.post(
          `/api/v2/account/init/${this.registerForm.userPhone}/${this.registerForm.verifyCode}?password=${this.registerForm.password}`
        );
        // console.log('注册=====',res)
        if (!res.sucess) return this.$message.error("註冊失敗，請稍後重識");
        this.$message.success("註冊成功，請登錄");
        this.fnchangePasswordLogin();
        window.sessionStorage.setItem("token", res.data);
      });
    },
    //登录
    fnToLogin() {
      this.$refs.registerFormRef3.validateField(
        "userPhoneLogin",
        async (valid) => {
          if (valid) return;
          // console.log('验证手机号=====',valid)
          let url = !this.useCode
            ? `api/v2/account/pcLogin/${this.registerForm.userPhoneLogin}/1?password=${this.registerForm.password}`
            : `api/v2/account/pcLogin/${this.registerForm.userPhoneLogin}/2?password=${this.registerForm.verifyCode}`;
          const { data: res } = await this.$http.post(url);
          if (!res.sucess) return this.$message.error("登錄失敗");
          if (res.code == 400) return this.$message.error(res.msg);
          // console.log('dl=====',res)
          window.sessionStorage.setItem("token", res.data);
          this.$message.success("登錄成功");
          this.dialogVisible = false;
          this.$store.state.isDialogVisible = false;
          this.$store.dispatch("checkToken");
          this.isLogined = true;
          // window.sessionStorage.setItem('token',333)
          // this.$router.push('/home')
        }
      );
    },
    async getMyAssociationList() {
      const { data: res } = await this.$http.get(
        `/api/v2/member/${this.user_id}/association`
      );
      if (!res.sucess) return this.$message.error("獲取失敗");
      // console.log('我的协会====',res.data)
      if (res.data.length > 0) {
        let filterArr = res.data.filter((item) => {
          if (item.association_id == "SZTX") {
            return item;
          }
        });
        // console.log(filterArr)
        if (filterArr.length == 0) {
          this.isHasAssociation = true;
        }
      } else {
        // this.isHasAssociation=true;
      }
    },
    fnToMyRights() {
      this.isHasAssociation = false;
      this.$router.push({
        path: `/my_rights`,
      });
    },
    //修改密码
    fnModifyPassword() {
      this.$refs.registerFormRef2.validate(async (valid) => {
        // console.log('验证修改密码=====',valid)
        if (!valid) return;
        const { data: res } = await this.$http.post(
          `api/v2/account/updatePwd/${this.registerForm.userPhoneLogin}/${this.registerForm.verifyCode}?password=${this.registerForm.password}`
        );
        // console.log('修改密码=====',res)
        if (!res.sucess) return this.$message.error("修改密碼失敗，請稍後重識");
        this.$message.success("修改密碼成功，請重新登錄");
        this.fnchangePasswordLogin();
        window.sessionStorage.setItem("token", res.data);
      });
    },
    //验证手机号是否已经注册过
    async checkPhone() {
      const { data: res } = await this.$http.post(
        `/api/v2/account/initVariable/${this.registerForm.userPhone}`
      );
      if (!res.sucess) return this.$message.error("獲取失敗");
      // console.log('zsqqq=====',res)
      // console.log(this)
      // return callback(new Error("手机号已注册过，请登录"))
    },
  },
  watch: {
    menuRes(val) {
      // console.log('val====',val)
      val.map((item, index) => {
        if (item.url == this.$route.name) {
          this.activePath = index + "";
        }
      });
    },
    $route(to, from) {
      let flag = this.menuRes.filter((item, index) => {
        if (item.path == to.path || item.url == to.name) {
          item.idx = index;
          return item;
        }
      });
      if (flag.length > 0) {
        this.activePath = flag[0].idx + "";
      } else {
        this.activePath = 1 + "";
      }
    },
    activePath(val) {
      // console.log('val.activePath======',val)
    },
    isDialogVisible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$store.state.isDialogVisible = val;
    },
    validToken(val) {
      if (!val) {
        this.$store.state.msgNum = 0;
      }
      this.$store.dispatch("checkToken");
    },
    user_id(val) {
      if (val && this.isLogined) {
        this.getMyAssociationList();
      }
    },
  },
  activated() {
    //只刷新数据，不改变整体的缓存
    this.$store.dispatch("checkToken");
  },
  created() {
    this.$store.dispatch("getNavigate");
    this.$store.dispatch("getProfile");
    this.activePath = window.sessionStorage.getItem("activePath");
    this.lang =
      sessionStorage.getItem("language") &&
      sessionStorage.getItem("language") == "s"
        ? "繁体"
        : "簡體";
  },
  mounted() {
    this.$zhTran();
    //更换路由菜单对应变化
    // console.log(this.$route)
    this.menuRes.map((item, index) => {
      if (item.path == this.$route.path || item.type == this.$route.name) {
        this.activePath = index + "";
      }
    });
  },
};
</script>

<style lang="less" scoped>
.el-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 40px;
  box-sizing: content-box;
  .header_menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    .router-link-active {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        margin-right: 2px;
      }
      span {
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #20317f;
        letter-spacing: 0;
        font-weight: 400;
      }
    }

    /deep/.el-menu {
      border: none;
      .el-menu-item,
      .el-submenu__title {
        font-size: 18px;
        line-height: 24px;
        height: auto;
        margin: 0 10px;
        padding: 0;
      }
      .el-submenu__icon-arrow {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .header_btns {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-tag {
      font-family: "MicrosoftYaHei";
      font-size: 16px;
      color: #20317f;
      letter-spacing: 0;
      font-weight: 400;
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      margin-right: 20px;
      line-height: 20px;
      height: auto;
    }
    i {
      margin-right: 20px;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      b {
        position: absolute;
        top: -5px;
        right: -8px;
        font-size: 16px;
        background: crimson;
        color: #fff;
        border-radius: 22px;
        width: 18px;
        height: 18px;
        text-align: center;
        line-height: 18px;
      }
    }
    .el-button {
      padding: 5px 11px;
      background: #20317f;
      border-radius: 4px;
      color: #fff;
      line-height: 20px;
      border: none;
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
    }
    .el-icon-search {
      color: #20317F;
    }
  }
}
/deep/.el-dialog {
  border-radius: 8px;
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog--center .el-dialog__body {
  padding: 0;
}
.login_container {
  height: 100%;
  // background: rgba(0, 0, 0, 0.75);
}
.login_box {
  width: 600px;
  height: 526px;
  background: #f1f3f4;
  border-radius: 8px;
  position: relative;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  .avatar_box {
    width: 273px;
    height: 68px;
    margin: auto;
    padding-top: 22px;
    // img {
    //   width: 100%;
    //   height: 100%;
    // }
    h3 {
      font-size: 24px;
      text-align: center;
      font-weight: bold;
      color: #333333;
      line-height: 68px;
    }
    i {
      position: absolute;
      right: 25px;
      top: 25px;
      font-size: 28px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
/deep/ .tabs_menu {
  .el-tabs__header {
    padding: 0 72px;
  }
  .el-tabs__nav {
    width: 100% !important;
    margin-top: 6px;
  }
  .el-tabs__active-bar {
    width: 50% !important;
  }
  .el-tabs__item {
    width: 50% !important;
    text-align: center;
    font-size: 20px;
    padding: 20px;
    height: auto;
    line-height: 20px;
  }
  .el-tabs__item:hover {
    color: #20317F !important;
  }
  .el-tabs__item.is-active {
    color: #20317F !important;
  }
  .el-tabs__active-bar {
    background-color: #20317F !important;
  }
  .el-tabs__content {
    position: static !important;
  }
}
/deep/ .login_form {
  // position: absolute;
  // top: 140px;
  width: 100%;
  padding: 9px 72px 0;
  box-sizing: border-box;
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-input {
    font-size: 16px !important;
  }
  .el-input__inner {
    border: none;
    border-bottom: 1px solid #d6d5d5;
    background-color: transparent;
    color: #000;
    border-radius: 0;
  }
}
/deep/ .code_input {
  .el-form-item__content {
    position: relative;
  }

  .code_btn {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 16px;
    color: #20317F;
    cursor: pointer;
  }
  .count {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 16px;
    color: #ccc;
  }
}
/deep/ .tips {
  font-size: 12px;
  color: rgba(0, 0, 0, 1);
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #20317F !important;
    border-color: #20317F !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #20317F !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #20317F !important;
  }
}
.remmber_btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    margin-top: 10px;
    font-size: 14px;
    color: #000;
  }
  span:hover {
    color: #20317F;
    text-decoration: underline;
    cursor: pointer;
  }
}

.btn {
  width: 271px;
  height: 45px;
  margin: auto;
  position: absolute;
  left: 50%;
  bottom: 53px;
  transform: translate(-50%, 0);
  button {
    width: 100%;
    height: 100%;
    border-radius: 45px;
    line-height: 45px;
    background: #394599;
    color: #ffffff;
    padding: 0;
    font-size: 16px;
  }
}
/deep/ .tips_pop {
  border-radius: 22px;
  margin-top: 20vh !important;
  .el-dialog__title {
    line-height: 60px;
    font-size: 20px;
    color: #303133;
    font-weight: bold;
  }
  p {
    font-size: 20px;
    padding: 0 30px;
    color: #333;
    margin: 30px 0;
  }
  i {
    position: absolute;
    right: 25px;
    top: 25px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  .pop-con {
    display: flex;
    justify-content: space-around;
    padding-bottom: 20px;
    button {
      width: 40%;
      display: block;
      background: #f12e2b;
      border-radius: 27px;
      font-size: 16px;
      color: #ffffff;
      padding: 14px 0;
      margin-bottom: 9px;
      border: none;
    }
    button:last-child {
      background: #eeeeee;
      color: #f12e2b;
    }
  }
}
.nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: #20317F;
  color: #fff;
  padding: 10px 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 16px;
  span {
    color: #fff;
  }
  h3 {
    font-size: 18px;
  }
  i {
    font-size: 22px;
  }
}
.el-menu--horizontal > .el-menu-item a,
.el-menu--horizontal > .el-menu-item a:hover {
  color: rgb(65, 65, 65);
}
.el-menu-item.is-disabled {
  opacity: 1;
  display: flex;
  align-items: center;
}
.el-menu-item.is-disabled a {
  color: #222222;
  line-height: 25px;
}
</style>
